


























import { defineComponent, PropType } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import TrButton from '@front-app/components/buttons/TrButton.vue';
import UserAvatar from '@front-app/components/user/avatar.vue';
import { UserAvatarStore } from '@front-app/store/singletons/User';
import { Size } from '@front-app/components/constants';
import { useUsername } from '@front-app/hooks/useTranslate';
import { STATUS } from '@front-app/constants/state';
import { UserAccountStatus } from '@front-app/services/UserApi/UserModel';
import { UserReportResult } from '@front-app/services/CommunityApi/CommunityReportsApi';

export default defineComponent({
	components: {
		UserAvatar,
		TrButton,
		FontAwesomeIcon,
	},
	props: {
		user: {
			type: Object as PropType<UserReportResult>,
			required: true,
		},
		isRemoveEnabled: Boolean,
	},
	setup(props, ctx) {
		const getUsername = useUsername(ctx);
		return {
			getUsername,
			UserAccountStatus,
			STATUS,
			// Avatar
			fetchAvatar: UserAvatarStore.fetch,
			getAvatar: UserAvatarStore.get,
			Size,
		};
	},
});
